var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c("div", { staticClass: "page-header-top-container" }, [
          _c("div", { staticClass: "page-name" }, [
            _vm._v(
              "\n                " + _vm._s(_vm.question) + "\n            "
            )
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary waves-effect pull-right",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.backButton()
                }
              }
            },
            [_vm._v("Back")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c(
            "div",
            { staticClass: "cards-container" },
            [
              _c(
                "draggable",
                {
                  staticClass: "drag-view",
                  on: {
                    change: function($event) {
                      return _vm.changePosition()
                    }
                  },
                  model: {
                    value: _vm.imageList,
                    callback: function($$v) {
                      _vm.imageList = $$v
                    },
                    expression: "imageList"
                  }
                },
                [
                  _vm._l(_vm.imageList, function(image, index) {
                    return [
                      _c("div", { staticClass: "col-4 mb-5" }, [
                        _c("div", { staticClass: "cards-block" }, [
                          _c("div", { staticClass: "card" }, [
                            _c("img", {
                              key: index,
                              staticClass: "card-img-top",
                              attrs: { src: image.image, alt: "Image" }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "card-body" }, [
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: image.status == 1,
                                      expression: "image.status == 1"
                                    }
                                  ],
                                  staticClass: "mr-2 btn btn-danger pull-right",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.deleteQuestionImage(image.id)
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-trash-o",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: image.status != 1,
                                      expression: "image.status != 1"
                                    }
                                  ],
                                  staticClass:
                                    "mr-2 btn btn-success pull-right",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.changeQuestionImageStatus(
                                        image.id
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-check",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: image.status != 1,
                                      expression: "image.status != 1"
                                    }
                                  ],
                                  staticClass: "mr-2 btn btn-danger pull-right",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.deleteQuestionImage(image.id)
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-times",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                ]
                              )
                            ])
                          ])
                        ])
                      ])
                    ]
                  })
                ],
                2
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dca97a50", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dca97a50","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/forum/ListForumQuestionImages.vue
// module id = null
// module chunks = 